import Image from 'next/image';
import { GarantieWrapper } from './CarigamiGarantie.styles';
import GuaranteeImage from './garantie.png';

const Garantie = () => (
  <GarantieWrapper
    href="/conditions-garantie.htm"
    title="Garantie meilleur prix"
    target="_blank"
    rel="noopener noreferrer"
  >
    <Image
      src={GuaranteeImage}
      alt="Garantie meilleur prix"
      width={90}
      height={90}
    />
  </GarantieWrapper>
);

export { Garantie };
